import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { SignUpLink } from './SignUp';
import { PasswordForgetLink } from './PasswordForget';
import { auth, firebase, db } from '../../firebase';
import * as routes from '../../constants/routes';
import logo from '../../assets/logo.png';
import SignIn from './SignIn.css'




const SignInPage = ({ history }) =>
  <div className="container sign-in">
    <div className="text-center">
      <img src={logo} />
      <h4> Log in to Kinnected or <SignUpLink /></h4>
    </div>
    <SignInForm history={history} />
  </div>

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

class SignInForm extends Component {

  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  getThis() {
    return this;
  }

  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;

    const {
      history,
    } = this.props;

    auth.doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push('/');
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  loginWithFb = async () => {
    const result = await auth.auth.signInWithPopup(firebase.provider);
    const userInfo = extractUserInfo(result);

    if(result.additionalUserInfo.isNewUser){
      db.doCreateUser(userInfo);
    }
    this.setState(() => ({ ...INITIAL_STATE }));
    this.getThis().props.history.push('/');
  }

  loginWithGoogle = async () => {
    const result = await auth.auth.signInWithPopup(firebase.googleProvider);
    const userInfo = extractUserInfo(result);

    if (result.additionalUserInfo.isNewUser) {
      db.doCreateUser(userInfo);
    }
    this.setState(() => ({ ...INITIAL_STATE }));
    this.getThis().props.history.push('/');
  }

  render() {
    const {
      email,
      password,
      error,
    } = this.state;

    const isInvalid =
      password === '' ||
      email === '';

    return (
      <div className="sign-in-container">
        <div className="row">
          {/*<div className="col-sm-12">
            <p>Sign in using social media</p>
          </div><div className="col-sm-12">
            <button className="btn btn-lg fb-button" onClick={this.loginWithFb}>
              f
            </button>

            <button className="btn btn-lg google-btn" onClick={this.loginWithGoogle}> G</button>
          </div>*/}
        </div>
        <form onSubmit={this.onSubmit} className="form-container">
          {/*<p>or Sign in using email address</p>*/}

          <div className="user-name">
            <input
              value={email}
              onChange={event => this.setState(byPropKey('email', event.target.value))}
              type="email"
              placeholder="Email"
            />
          </div>
          <div className="password">
            <input
              value={password}
              onChange={event => this.setState(byPropKey('password', event.target.value))}
              type="password"
              placeholder="Password"
            />
          </div>
          <div className="remember-forgot-field">
            <div className="rememberMe">
              <p>
                <label htmlFor="remember">
                  <input type="checkbox" id="remember" name="remember" /> Remember me
                </label>
              </p>
            </div>
            <div className="forgotLink">
              <PasswordForgetLink />
            </div>
          </div>
          <div className="signInButtonContainer">
            <button className="kinnected-orange" disabled={isInvalid} type="submit">
              SIGN IN
            </button>
          </div>
          {error && <p>{error.message}</p>}

        </form>
      </div>
    );
  }
}

const extractUserInfo = (result) => {
  const additionalUserInfo = result.additionalUserInfo;
  const profile = additionalUserInfo.profile;
  const user = {
    accountType: 0,
    firstName: profile.given_name ? profile.given_name : profile.first_name ,
    lastName: profile.family_name ? profile.family_name : profile.last_name,
    email: profile.email,
    id: result.user.uid,
    displayName: result.user.displayName,
    profilePicUrl: result.user.photoURL
  }
  return user;
}

export default withRouter(SignInPage);

export {
  SignInForm,
};


// WEBPACK FOOTER //
// ./src/components/account/SignIn.js